module.exports = __webpack_public_path__ + "img/Frame 1120 (1).36afcff5.png";